// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ResetPassword-__style___3BpP6","left":"app-pages-ResetPassword-__style___1RlTc","right":"app-pages-ResetPassword-__style___1QKv0","description-reset-password":"app-pages-ResetPassword-__style___12LD-","title-panel":"app-pages-ResetPassword-__style___wRMNY","submit-btn":"app-pages-ResetPassword-__style___1XTHu","submit-btn-container":"app-pages-ResetPassword-__style___BznvV","back-to-login":"app-pages-ResetPassword-__style___2zKQn"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/ResetPassword/style.css
// module id = 536
// module chunks = 0